import axios from 'axios';

import { useQuery } from 'react-query';

import { useRoutesAndPortsState, Route } from '@/features/shared/hooks/useRoutesAndPorts.state';

type Port = {
  code: string;
  name: string;
};

export type GetRoutesAndPortsResponse = {
  ports: Port[];
  routes: Route[];
};

const getRoutesAndPortsAsync = () => axios.get<GetRoutesAndPortsResponse>(`/mocks/ports_and_routes.json`);

export const useGetRoutesAndPortsAsync = () =>
  useQuery({
    queryKey: ['ports_and_routes'],
    queryFn: async () => {
      const { data } = await getRoutesAndPortsAsync();
      return data;
    },
    select: ({ routes, ports }) => {
      const portsAsMap = new Map<string, string>(ports.map(({ code, name }) => [code, name]));

      return { routes, ports: portsAsMap };
    },
    onSuccess: ({ routes, ports }) => {
      useRoutesAndPortsState.setState({
        routes,
        ports,
      });
    },
  });
